module.exports = __webpack_public_path__ + "img/office.e7e73b3.png";